import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { TextField } from '@mui/material';
import styled from 'styled-components';

import { Action } from 'state';
import Field from 'types/Field';
import Section from 'types/Section';
import UnitType from 'types/UnitType';

const StyledFieldContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-input {
    font-size: 0.8rem;
  }
`;

const StyledLabel = styled(Typography)`
  margin-bottom: 0.2rem;
`;

const StyledUnitLabel = styled.label`
  margin-left: 0.5rem;
  color: grey;
  font-size: 0.875rem;
`;

interface TextFieldPreviewProps {
  section: Section;
  field: Field;
  numeric?: boolean;
  unit?: UnitType | null;
  multiline?: boolean;
  dispatch: (action: Action) => void;
}

const TextFieldPreview: React.FC<TextFieldPreviewProps> = ({
  section,
  field,
  numeric = false,
  unit,
  multiline = false,
  dispatch,
}) => {
  const inputType = numeric ? 'number' : 'text';
  const inputRows = multiline ? 3 : undefined;

  const handleOnChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { value } = e.target;
      dispatch({ type: 'set-text-field-value-preview', section, field, value });
    },
    [dispatch, section, field],
  );

  return (
    <Box>
      <StyledLabel variant="body2">{field.label}</StyledLabel>
      <StyledFieldContainer>
        <StyledTextField
          size="small"
          variant="outlined"
          type={inputType}
          multiline={multiline}
          rows={inputRows}
          value={field.preview_default_value[0]}
          hiddenLabel
          fullWidth
          onChange={handleOnChange}
          style={{ width: unit ? '80%' : '100%' }}
        />
        {unit && <StyledUnitLabel>{unit}</StyledUnitLabel>}
      </StyledFieldContainer>
    </Box>
  );
};

export default TextFieldPreview;
